<template>
  <div class="sigin-wrap">
    <div class="go-back" @click="goBack"></div>
    <div class="content">
      <p class="title">注册信息填写</p>
      <el-form :model="ruleForm" label-position="top" hide-required-asterisk :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="邮箱*" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="密码*" prop="password">
          <el-input v-model="ruleForm.password" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码*" prop="password1">
          <el-input v-model="ruleForm.password1" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="姓名*" prop="username">
          <el-input v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item label="电话*" prop="tel">
          <el-input v-model="ruleForm.tel"></el-input>
        </el-form-item>
        <el-form-item label="单位性质*" prop="company_type">
          <el-select v-model="ruleForm.company_type" placeholder="请选择">
            <el-option label="医院" value="1"></el-option>
            <el-option label="组织" value="2"></el-option>
            <el-option label="科研院校" value="3"></el-option>
            <el-option label="公司" value="4"></el-option>
            <el-option label="其他" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位名称*" prop="company">
          <el-input v-model="ruleForm.company"></el-input>
        </el-form-item>
        <el-form-item label="背景*" prop="background">
          <el-select v-model="ruleForm.background" placeholder="请选择">
            <el-option label="学术" value="1"></el-option>
            <el-option label="非学术" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份*" prop="identity">
          <el-select v-model="ruleForm.identity" placeholder="请选择">
            <el-option label="学者" value="1"></el-option>
            <el-option label="医生" value="2"></el-option>
            <el-option label="研究员" value="3"></el-option>
            <el-option label="技术员" value="4"></el-option>
            <el-option label="患者" value="6"></el-option>
            <el-option label="罕见病组织访问者" value="7"></el-option>
            <el-option label="其他" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件类型" prop="type_ID">
          <el-select v-model="ruleForm.type_ID" placeholder="请选择">
            <el-option label="身份证" value="1"></el-option>
            <el-option label="工号" value="2"></el-option>
            <el-option label="护照" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号" prop="cardid">
          <el-input v-model="ruleForm.cardid"></el-input>
        </el-form-item>
        <el-form-item label="地址（省）" prop="province">
          <el-input v-model="ruleForm.province"></el-input>
        </el-form-item>
        <el-form-item label="地址（市）" prop="city">
          <el-input v-model="ruleForm.city"></el-input>
        </el-form-item>
        <el-form-item label="地址（区）" prop="county">
          <el-input v-model="ruleForm.county"></el-input>
        </el-form-item>
        
        <el-form-item class="flex-box space-center">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
    data() {
      var validateComfirmEmail = (rule, value, callback) => {
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test( value )) {
          callback(new Error('请输入正确的邮箱'))
        } else {
          callback()
        }
      }
      var validateComfirmPwd = (rule, value, callback) => {
        if (this.ruleForm.password !== value) {
          callback(new Error('确认密码与新密码不一致！'))
        } else {
          callback()
        }
      }
      var validateComfirmCardId = (rule, value, callback) => {
        if (value == '') {
          callback()
          return
        }
        if (this.ruleForm.type_ID == 1) {
          const reg = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
          if (!reg.test( value )) {
            callback(new Error('请输入正确身份证号'))
          } else {
            callback()
          }
        } else if (this.ruleForm.type_ID == 3) {
          const reg = /^([a-zA-z]|[0-9]){5,17}$/
          if (!reg.test( value )) {
            callback(new Error('请输入正确护照号'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        ruleForm: {
          email: '',
          password: '',
          password1: '',
          background: '',
          position: '',
          institutions: '',
          address: '',
          tel: '',
          delivery: false,
          username: '',
          company: '',
          type_ID: '',
          cardid: ''
        },
        rules: {
          email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            { validator: validateComfirmEmail, trigger: 'blur' }
          ],
          password: [
            { required: true, message: '密码固定8位，必须包含数字，大写字母，小写字母', trigger: 'change' },
            { pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[A-Za-z0-9 _]{8}$/, message: `密码固定8位，必须包含数字，大写字母，小写字母`, trigger: 'blur'}
          ],
          password1: [
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { validator: validateComfirmPwd, trigger: 'blur' }
          ],
          background: [
            { required: true, message: '请选择背景', trigger: 'change' }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'change' }
          ],
          tel: [
            { required: true, message: '请输入电话', trigger: 'change' },
            {pattern: /^(17[0-9]|14[5|7]|13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/, message: `请输入正确的格式`, trigger: 'blur'}

          ],
          username: [
            { required: true, message: '请输入姓名', trigger: 'change' }
          ],
          company: [
            { required: true, message: '请输入所属组织单位', trigger: 'change' },
            {pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/, message: `只能是汉字、字母、数字、-、_`, trigger: 'blur'}
          ],
          type_ID: [
            { required: false, message: '请选择证件类型', trigger: 'change' }
          ],
          cardid: [
            { required: false, message: '请输入证件号', trigger: 'change' },
            { validator: validateComfirmCardId, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.ruleForm.cardid == '') {
              this.ruleForm.type_ID = ''
            }
            this.$store.dispatch('setSignInfo', this.ruleForm)
            localStorage.setItem('email', this.ruleForm.email)
            this.$router.push('/send_code')
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
</script>

<style lang='scss' scoped>
.sigin-wrap {
  width: 1139px;
  margin: 21px auto 44px;
  .go-back {
    width: 29px;
    height: 29px;
    background: url('../../assets/icon/back-icon.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .content {
    width: 560px;
    margin: 10px auto 0;
    .title {
      color: #333333;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
    }
    .demo-ruleForm {
      margin-top: 36px;
    }
  }
}
</style>
